class Header {
    constructor() {
        this.components = document.querySelectorAll('.m-header');

        this.components.forEach((component) => {
            this.init(component);
        });
    }

    init(component) {
        const classes = {
            pinned: 'is-pin',
            unpinned: 'is-unpin',
        };
        const logo = component.querySelector('.m-header__logo');
        const logoRect = logo.getBoundingClientRect();
        const navs = component.querySelector('.m-header__navs');
        let threshold = logoRect.height;
        let scrollTop = 0;
        let ticking = false;

        document.addEventListener(
            'scroll',
            function () {
                onScroll();
            },
            false
        );

        function onScroll() {
            scrollTop = window.pageYOffset;
            requestTick();
        }

        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(update);
            }
            ticking = true;
        }

        function update() {
            if (scrollTop < threshold) {
                unpin();
            } else if (scrollTop > threshold) {
                pin();
            }

            ticking = false;
        }

        function pin() {
            if (navs.classList.contains(classes.unpinned)) {
                navs.classList.remove(classes.unpinned);
                navs.classList.add(classes.pinned);
            }
        }

        function unpin() {
            if (
                navs.classList.contains(classes.pinned) ||
                !navs.classList.contains(classes.unpinned)
            ) {
                navs.classList.remove(classes.pinned);
                navs.classList.add(classes.unpinned);
            }
        }
    }
}

export default Header;
